export default __webpack_public_path__ + "static/claude_code-4e754105a1ec2dbe0602b798caed4211.png";